import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { clientToken } from '../constants/auth-state';
import { PRODUCT_CODES } from '../constants/product.constants';
import { AuthService } from '../services/auth.service';
import { ProductAccessService } from '../services/product-access.service';
import { UserPermissionService } from '../services/user-permission.service';

/**
 * Root (`/`) guard. Starts login for visitors; sends a logged-in agent to the product chosen
 * this session, straight into their only product, or to the selection page.
 */
export const postLoginRedirectGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const productAccessService = inject(ProductAccessService);

  if (!authService.isAuthenticated()) {
    authService.login();
    return false;
  }

  // Prospects have no product assignment; they keep the start page they had before.
  if (clientToken()) {
    await inject(UserPermissionService).initializeUserPermissions();
    return router.parseUrl(productAccessService.getLandingUrl(PRODUCT_CODES.RETAIL_HEALTH));
  }

  return router.parseUrl(await productAccessService.resolveEntryUrl());
};
